//* Libraries imports
import { useState } from "react";
import { Dialog, DialogTitle, DialogContent, IconButton } from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import { PlusIcon, Search } from "lucide-react";

//* Componentes imports
import { Separator } from "@/components/ui/separator";
import { Button } from "@/components/ui/button";
import { Card, CardContent } from "@/components/ui/card";
import { DataTable } from "@/components/ui";
import { Required } from "@/components/ui/required";

type FormSectionProps = {
  forms: any[];
  activity: any;
  handleFieldChange: (field: string, value: any) => void;
  error?: any;
};

export const FormSection = ({
  forms,
  activity,
  handleFieldChange,
  error,
}: FormSectionProps) => {
  const [search, setSearch] = useState("");
  const [formModal, setFormModal] = useState(false);

  return (
    <section className="flex flex-col w-full items-start rounded-xl">
      {formModal == true && (
        <Dialog
          maxWidth="lg"
          fullWidth
          open={formModal}
          onClose={() => {
            setFormModal(false);
          }}
        >
          <DialogTitle>
            <h1 className="text-2xl font-bold mb-6">Vincular formulário</h1>
            <IconButton
              aria-label="close"
              onClick={() => {
                setFormModal(false);
              }}
              sx={{ position: "absolute", right: 8, top: 8 }}
            >
              <CloseIcon />
            </IconButton>
          </DialogTitle>
          <DialogContent>
            <div
              className="grid grid-cols-1"
              style={{
                padding: 10,
                backgroundColor: "#f2f2f2",
                margin: 2,
                height: "50vh",
              }}
            >
              <div
                className="scrollbar-hide"
                style={{
                  backgroundColor: "white",
                  borderRadius: 10,
                  position: "relative",
                  margin: 2,
                  height: "100%",
                  overflow: "scroll",
                }}
              >
                <div
                  style={{
                    background: "url(/pontilhado.png)",
                    position: "absolute",
                    zIndex: 1,
                    top: 20,
                    height: 110,
                    width: 100,
                    left: -82,
                    objectFit: "contain",
                    backgroundRepeat: "repeat-y",
                    backgroundSize: "262px 50px",
                  }}
                ></div>
                <div style={{ padding: 5 }}>
                  <p
                    style={{
                      display: "flex",
                      alignItems: "center",
                      marginTop: 30,
                      zIndex: 2,
                    }}
                  >
                    <svg
                      id="atividades-img"
                      xmlns="http://www.w3.org/2000/svg"
                      style={{ marginRight: 5 }}
                      width={18}
                      height="18"
                      viewBox="0 0 15 20"
                    >
                      <path
                        d="M17.6307 0.00157104C14.117 -0.0614313 10.1098 1.77539 7.57338 4.62475C5.14943 4.6705 2.78923 5.66429 1.05152 7.4021C0.950272 7.50185 0.914273 7.65111 0.958522 7.78612C1.00352 7.92187 1.12052 8.02012 1.26152 8.04037L4.15195 8.45439L3.79496 8.85416C3.66221 9.00266 3.66896 9.22842 3.80996 9.36943L8.6301 14.1899C8.70285 14.2626 8.79885 14.2994 8.8956 14.2994C8.98485 14.2994 9.07409 14.2679 9.14534 14.2041L9.54508 13.8471L9.95907 16.7377C9.97932 16.8787 10.0903 16.9822 10.2246 17.0272C10.2591 17.0385 10.2951 17.0437 10.3318 17.0437C10.4383 17.0437 10.5471 16.9972 10.6221 16.923C12.3358 15.2091 13.3295 12.8488 13.3752 10.4247C16.2274 7.88287 18.0791 3.87697 17.9974 0.367585C17.9921 0.168077 17.8309 0.00682124 17.6307 0.00157104ZM14.1747 6.47582C13.8095 6.84108 13.3295 7.02409 12.8488 7.02409C12.368 7.02409 11.888 6.84108 11.5228 6.47582C10.7923 5.74454 10.7923 4.55499 11.5228 3.82372C12.254 3.09244 13.4435 3.09244 14.1747 3.82372C14.906 4.55499 14.906 5.74529 14.1747 6.47582Z"
                        fill="#7D8592"
                      />
                      <path
                        d="M2.043 12.6785C1.24052 13.4811 0.13879 17.1067 0.0157927 17.517C-0.0239564 17.649 0.0127928 17.7922 0.109541 17.8897C0.181539 17.9618 0.276787 18 0.375035 18C0.411034 18 0.447033 17.9948 0.483032 17.9843C0.893273 17.8612 4.51869 16.7595 5.32118 15.9569C6.22491 15.0531 6.22491 13.5823 5.32118 12.6785C4.4167 11.7748 2.94673 11.7755 2.043 12.6785Z"
                        fill="#7D8592"
                      />
                    </svg>{" "}
                    <b>Formuários ({forms.length})</b>
                  </p>
                </div>

                {forms.map((form, index) => (
                  <div
                    key={index}
                    style={{
                      textOverflow: "ellipsis",
                      padding: 5,
                      cursor: "pointer",
                    }}
                    onClick={(e) => {
                      if (form._id == activity.typeRefId) {
                        handleFieldChange("typeRefId", "");
                      } else {
                        handleFieldChange("typeRefId", form._id);
                      }
                    }}
                  >
                    <p
                      style={{
                        color:
                          activity.typeRefId == form._id
                            ? "#1777CF"
                            : "rgba(0, 0, 0, 0.87)",
                        display: "flex",
                        justifyContent: "space-between",
                      }}
                    >
                      <span>
                        {index + 1}. {form.name}
                      </span>
                    </p>
                    <Separator style={{ borderWidth: 0.5, marginTop: 5 }} />
                  </div>
                ))}
              </div>
            </div>
          </DialogContent>
        </Dialog>
      )}
      {/* Header */}
      <Card className="w-full border border-[#D8E0F0] rounded-[14px] bg-[#FCFCFC] hover:border-[#c8d0e0] transition-colors">
        <CardContent className="p-[20px] ">
          <div className="flex w-full h-9 items-center justify-between mb-5">
            <div className="flex flex-col">
              <h1 className="text-xl font-bold" id="atividades">
                Formulários ({activity.typeRefId ? 1 : 0}) <Required />
              </h1>
              {error?.validationErrors?.typeRefId && (
                <p className="text-xs text-red-500 font-normal">
                  O formulário é obrigatório
                </p>
              )}
            </div>

            <div className="flex items-center gap-5">
              <Button
                size="icon"
                className="w-[30px] h-[30px] bg-blue-500 rounded-lg"
                onClick={() => {
                  setFormModal(true);
                }}
              >
                <PlusIcon className="h-4 w-4 text-white" />
              </Button>
            </div>
          </div>

          <div className="mb-4 flex w-full" style={{ position: "relative" }}>
            <input
              type="text"
              value={search}
              onChange={(e) => {
                setSearch(e.target.value);
              }}
              placeholder="Pesquisar"
              className="p-2 border rounded"
              style={{
                width: "-webkit-fill-available",
                borderRadius: 20,
                paddingLeft: 40,
              }}
            />
            <Search
              style={{
                position: "absolute",
                top: "20%",
                left: 10,
                color: "grey",
              }}
            />
          </div>

          <div className="w-full">
            <DataTable
              hide_search
              hide_add
              hideEdit
              columns={[
                {
                  image: "photoUrl",
                  placeholderImage: "/documents.svg",
                  style_image: {
                    borderRadius: 10,
                    border: "1px solid lightgrey",
                    background: "rgb(244, 244, 244)",
                    width: 30,
                    height: 30,
                    objectFit: "contain",
                  },

                  key: "name",
                  header: "Nome",
                  render: (value: any) => String(value || ""),
                },
              ]}
              hide_header
              data={
                activity.typeRefId == ""
                  ? []
                  : forms?.filter(
                      (item) =>
                        item._id == activity.typeRefId &&
                        item.name
                          ?.toLowerCase()
                          ?.includes(search.toLowerCase()),
                    )
              }
              basePath="forms"
              onDelete={(e) => {
                handleFieldChange("typeRefId", "");
              }}
              newFormat
            />
          </div>
        </CardContent>
      </Card>
    </section>
  );
};
